module.exports = __webpack_public_path__ + "static/media/ru.642e4a1a.png";